import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiUnlock, FiVideo, FiClock, FiCheckCircle, FiCoffee, FiLock } = FiIcons;

const STATES = [
  { id: 'open', label: 'OPEN', color: '#10B981', icon: FiUnlock },
  { id: 'recording', label: 'RECORDING', color: '#E11D48', icon: FiVideo },
  { id: 'leadin', label: 'LEAD-IN', color: '#F59E0B', icon: FiClock },
  { id: 'wrapup', label: 'WRAP UP', color: '#64748B', icon: FiCheckCircle },
  { id: 'break', label: 'BREAK', color: '#8B5CF6', icon: FiCoffee },
  { id: 'closed', label: 'CLOSED', color: '#52525B', icon: FiLock },
];

export default function DoorControlGrid({ activeState, setActiveState, onTimeActionClick }) {
  return (
    <div className="transition-all duration-500 w-full opacity-100">
      <h2 className="text-xs font-semibold tracking-tight text-zinc-500 mb-3 px-1 uppercase">
        Manual Overrides
      </h2>
      <div className="grid grid-cols-2 gap-3">
        {STATES.map((state) => {
          const isActive = activeState === state.id;
          return (
            <button
              key={state.id}
              onClick={() => {
                if (isActive) {
                  // Revert to The Schedule (AUTO)
                  setActiveState('auto');
                } else {
                  if (['break', 'leadin', 'wrapup'].includes(state.id)) {
                    onTimeActionClick(state.id);
                  } else {
                    setActiveState(state.id);
                  }
                }
              }}
              style={{
                borderColor: isActive ? state.color : undefined,
                backgroundColor: isActive ? `${state.color}15` : undefined,
                boxShadow: isActive 
                  ? `0 4px 24px ${state.color}15, inset 0 1px 0 rgba(255,255,255,0.1)` 
                  : 'inset 0 1px 0 rgba(255,255,255,0.02)',
              }}
              className={`relative h-28 md:h-32 rounded-2xl flex flex-col items-center justify-center gap-2.5 transition-all duration-300 overflow-hidden border ${
                isActive 
                  ? 'scale-[1.02] z-10' 
                  : 'border-white/5 bg-zinc-900/40 hover:bg-zinc-800/60 hover:scale-[1.02]'
              }`}
            >
              <div className="absolute inset-0 bg-gradient-to-b from-white/[0.04] to-transparent pointer-events-none" />
              
              <SafeIcon 
                icon={state.icon} 
                className={`text-2xl transition-colors duration-300 relative z-10 ${
                  !isActive && 'text-zinc-500'
                }`}
                style={isActive ? { color: state.color } : {}}
              />
              <span 
                className={`text-sm font-semibold tracking-tight relative z-10 transition-colors duration-300 ${
                  !isActive && 'text-zinc-500'
                }`}
                style={isActive ? { color: state.color } : {}}
              >
                {state.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}